module.exports = __webpack_public_path__ + "static/media/oberflex-aniegret461-2560x1440.39f22368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aniegret461-2560x1440.jpg
// module id = 979
// module chunks = 37